export default __webpack_public_path__ + "static/media/Steelforged Salvation of the Undying Atlantis.9ec46bda.jpg";